import { ReactComponent as ShopBag } from '@assets/icons/shop-art-bag.svg';
import { ReactComponent as ShopConnect } from '@assets/icons/shop-art-connect.svg';
import { ReactComponent as ShopNoFee } from '@assets/icons/shop-art-no-fee.svg';
import { ReactComponent as ShopPhone } from '@assets/icons/shop-art-phone.svg';
import { useTranslation } from '@shared/core/i18n';
import { Box, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { ShopFeatureBox } from './HeroContent.styles';

interface HeroContentProps {}

interface ShopFeatureProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
}

const ShopFeature = React.memo((props: ShopFeatureProps) => {
  const { icon, title, subtitle } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      flex={['1 0 50%', null, '1 0 25%']}
      alignItems="center"
      marginY={[5, null, 6]}
    >
      <Box marginBottom={3}>{icon}</Box>
      <TextV2
        fontSize={[15, null, 17]}
        typographyVariant="hed2"
        textAlign="center"
        component="p"
        color={'mono13'}
        letterSpacing="-0.2px"
      >
        {title}
      </TextV2>
      <TextV2
        fontSize={[13, null, 15]}
        typographyVariant="body1"
        textAlign="center"
        component="p"
        color={'brandWarmGray6'}
      >
        {subtitle}
      </TextV2>
    </Box>
  );
});

export const HeroContent: React.FC<HeroContentProps> = React.memo(() => {
  const { t2 } = useTranslation('sharedRegistry');
  const { heroContentHeader, heroContentTitle, shopTitle, shopSubtitle, connectTitle, connectSubtitle, noFeeTitle, noFeeSubtitle, shopWebTitle, shopWebSubtitle } =
    t2('publicShop');

  const featureContent: ShopFeatureProps[] = [
    {
      icon: <ShopBag />,
      title: shopTitle,
      subtitle: shopSubtitle,
    },
    {
      icon: <ShopConnect />,
      title: connectTitle,
      subtitle: connectSubtitle,
    },
    {
      icon: <ShopNoFee />,
      title: noFeeTitle,
      subtitle: noFeeSubtitle,
    },
    {
      icon: <ShopPhone />,
      title: shopWebTitle,
      subtitle: shopWebSubtitle,
    },
  ];

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      marginBottom={6}
    >
      <TextV2
        textAlign="center"
        typographyVariant="hed4"
        component="p"
        color={'brandWarmGray6'}
        marginBottom={3}
      >
        {heroContentHeader}
      </TextV2>
      <TextV2
        textAlign="center"
        fontFamily="Austin News Headline"
        fontSize="56px"
        lineHeight="68px"
        color={'brandWarmGray7'}
        marginBottom={6}
      >
        {heroContentTitle}
      </TextV2>
      <ShopFeatureBox
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
      >
        {featureContent.map(feature => {
          return (
            <ShopFeature
              key={feature.title}
              {...feature}
            />
          );
        })}
      </ShopFeatureBox>
    </Box>
  );
});
